/* eslint-disable complexity */
/* eslint-disable max-lines-per-function */
import { ArbeitszeitArbeitszeitantragStatus } from '@/gql/graphql';
import { StatusDetails } from './StatusDetails';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { getAntragsArt } from './AntragsArt';
import { antragsZeit } from '@/domain/arbeitszeiten/entities';

type StatusTextProps = {
  status: ArbeitszeitArbeitszeitantragStatus;
  aenderungsdatum?: Date;
  beginn?: antragsZeit;
  ende?: antragsZeit;
  mitarbeiter?: { vorname: string; nachname: string };
};

export function StatusText({
  status,
  aenderungsdatum,
  beginn,
  ende,
  mitarbeiter,
}: StatusTextProps) {
  const { t } = useTranslation();

  const antragsArt = getAntragsArt(beginn, ende);

  if (status === ArbeitszeitArbeitszeitantragStatus.Abgelehnt) {
    return (
      <div className="flex flex-col text-sm text-black font-semibold whitespace-nowrap w-full">
        <div className="flex items-center gap-2 font-semibold rounded-full w-full justify-between mt-2">
          <div className="flex items-center gap-2">
            {t('domain.arbeitszeiten.antrag.abgelehnt')}
          </div>
          {aenderungsdatum && (
            <div className="text-sm font-normal text-neutrals-N600">
              {`${dayjs(aenderungsdatum)
                .locale('de')
                .format('dd., DD. MMMM, HH:mm')} Uhr`}
            </div>
          )}
        </div>
        <div>
          {beginn && ende && mitarbeiter && (
            <StatusDetails
              beginn={beginn?.time}
              ende={ende?.time}
              mitarbeiter={mitarbeiter}
            />
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col text-sm text-black font-semibold whitespace-nowrap w-full">
      <div className="flex items-center gap-2 font-semibold rounded-full w-full justify-between">
        <div className="flex items-center gap-2">
          {t('domain.arbeitszeiten.antrag.genehmigt', { antragsArt })}
        </div>
        {aenderungsdatum && (
          <div className="text-sm font-normal text-neutrals-N600">
            {`${dayjs(aenderungsdatum)
              .locale('de')
              .format('dd., DD. MMMM, HH:mm')} Uhr`}
          </div>
        )}
      </div>
      <div>
        {status !== ArbeitszeitArbeitszeitantragStatus.Neu && (
          <StatusDetails
            beginn={beginn?.time}
            ende={ende?.time}
            mitarbeiter={mitarbeiter}
          />
        )}
      </div>
    </div>
  );
}
